import React, {Component} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';

class HalfTimeFullTime extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;

        return (<div className={marketStyle.marketGroup}>
            <div>
                <OddsCard store={store} market={markets[0]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[1]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[2]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
            </div>
            <div>
                <OddsCard store={store} market={markets[3]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[4]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[5]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
            </div>
            <div>
                <OddsCard store={store} market={markets[6]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[7]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
                <OddsCard store={store} market={markets[8]} homeTeam={this.props.homeTeam}
                          awayTeam={this.props.awayTeam}/>
            </div>
        </div>);
    }
}

export default HalfTimeFullTime;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/halfTimeFullTime.js